/* eslint-disable max-lines */
import { createTheme } from '@mui/material/styles';

import {
  CASTING_BUTTON_WIDTH,
  colorUsage,
  fontSize,
  fontWeight,
  getSpacing,
  letterSpacing,
  lineHeight,
  NAV_BAR_HEIGHT,
  FAQ_DOT_RIGHT_MARGIN,
  FAQ_DOT_RIGHT_WIDTH,
} from 'stylesheetB2c';

export const mUiTheme = createTheme({
  palette: {
    primary: { main: colorUsage.headerBackground },
    mode: 'dark',
  },
  typography: {
    body1: { fontWeight: fontWeight.bold },
  },
  components: {
    MuiBottomNavigation: {
      styleOverrides: {
        root: {
          height: NAV_BAR_HEIGHT,
          backgroundColor: colorUsage.navBarBackground,
          flexShrink: 0,
        },
      },
    },
    MuiRadio: {
      styleOverrides: {
        root: { paddingLeft: 0, paddingRight: 20, color: colorUsage.navigationButtonColor },
      },
    },
    MuiFab: {
      styleOverrides: {
        root: {
          backgroundColor: colorUsage.floatingButtonBackgroundColor,
          '&:hover': {
            backgroundColor: colorUsage.hoveredFloatingButtonBackgroundColor,
          },
          width: CASTING_BUTTON_WIDTH,
          height: CASTING_BUTTON_WIDTH,
        },
        // label: {
        //   display: 'flex',
        //   flexDirection: 'column',
        //   color: colorUsage.floatingButtonColor,
        //   fontSize: fontSize.tiny,
        //   whiteSpace: 'pre-line',
        // },
      },
    },

    MuiSlider: {
      styleOverrides: {
        rail: {
          backgroundColor: colorUsage.sliderLightColor,
          opacity: 1,
          height: '1px',
        },
        track: {
          backgroundColor: colorUsage.sliderDarkColor,
        },
        thumb: {
          backgroundColor: colorUsage.sliderDarkColor,
        },
      },
    },
    MuiTooltip: {
      styleOverrides: {
        tooltip: {
          backgroundColor: colorUsage.sliderDarkColor,
        },
      },
    },
    MuiSvgIcon: {
      styleOverrides: {
        colorPrimary: { color: colorUsage.svgIconPrimary },
      },
    },
    MuiIconButton: {
      styleOverrides: {
        root: {
          color: colorUsage.iconColor,
        },
        colorPrimary: {
          color: colorUsage.primaryIconButtonColor,
        },
      },
    },
    MuiList: {
      styleOverrides: {
        root: { backgroundColor: 'black' },
      },
    },
    MuiListItemText: {
      styleOverrides: {
        root: {
          cursor: 'pointer',
        },
        primary: {
          letterSpacing: letterSpacing.medium,
          fontWeight: fontWeight.normal,
          fontSize: fontSize.medium,
          lineHeight: lineHeight.XSmall,
          textOverflow: 'ellipsis',
          whiteSpace: 'nowrap',
          overflow: 'hidden',
        },
        secondary: {
          color: colorUsage.listItemSecondaryTextColor,
          letterSpacing: letterSpacing.medium,
          fontSize: fontSize.XSmall,
          textOverflow: 'ellipsis',
          whiteSpace: 'nowrap',
          overflow: 'hidden',
        },
        multiline: { marginTop: '0', marginBottom: '0' },
      },
    },
    MuiListItemSecondaryAction: {
      styleOverrides: {
        root: { right: getSpacing(1) },
      },
    },
    MuiListItem: {
      styleOverrides: {
        root: {
          '&.selected': {
            color: colorUsage.emphasisTextColor,
          },
          paddingTop: '7px',
          paddingBottom: '7px',
        },
      },
    },
    MuiBottomNavigationAction: {
      styleOverrides: {
        root: {
          color: colorUsage.navigationButtonColor,
          '&.Mui-selected': {
            color: colorUsage.selectedNavigationButtonColor,
          },
        },
        label: {
          fontSize: fontSize.tiny,
          textAlign: 'center',
          '&.Mui-selected': {
            fontSize: fontSize.tiny,
            fontWeight: fontWeight.bold,
          },
        },
      },
    },
    MuiAccordion: {
      styleOverrides: {
        root: {
          backgroundColor: 'inherit',
          color: 'inherit',
          letterSpacing: letterSpacing.medium,
          padding: `0 ${getSpacing(3)}`,
          margin: `0 0 ${getSpacing(8)}`,

          '&.expanded': {
            margin: `0 0 ${getSpacing(8)}`,
          },
        },
      },
    },
    MuiAccordionSummary: {
      styleOverrides: {
        root: {
          fontSize: fontSize.XSmall,
          fontWeight: fontWeight.bold,
          lineHeight: lineHeight.XXSmall,
          padding: 0,
          minHeight: 'auto',

          '&.expanded': {
            minHeight: 'auto',
          },
        },
        content: {
          margin: 0,

          '&.expanded': {
            margin: 0,
          },
        },
      },
    },
    MuiAccordionDetails: {
      styleOverrides: {
        root: {
          fontSize: fontSize.XXXSmall,
          lineHeight: lineHeight.XXXSmall,
          padding: `${getSpacing(2)} ${getSpacing(
            4,
          )} 0 calc(${FAQ_DOT_RIGHT_MARGIN} + ${FAQ_DOT_RIGHT_WIDTH}) `,
          display: 'block',
        },
      },
    },
  },
});
